/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './EmDiaValeMaisFooter.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

const categories = [
  {
    title: 'Meu financiamento',
    links: [
      { label: 'Meus boletos', href: 'boleto.html' },
      { label: 'Consultar Financiamento', href: 'consultar-financiamento.html' },
      { label: 'Renegociação', href: 'renegociacao-santander-financiamentos.html' },
      {
        label: 'Resumo e/ou cópia do contrato',
        href: 'https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:footer&int_campaign=resumo-copia-de-contrato',
        external: true,
      },
      {
        label: 'Transferência do Financiamento',
        href: 'https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:footer&int_campaign=transferencia-de-financiamento',
        external: true,
      },
    ],
  },
  {
    title: 'Produto',
    links: [
      {
        label: 'Simular agora',
        href: 'https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=footer&int_campaign=simular#/dados-pessoais',
        external: true,
      },
      { label: 'Financiar veículos', href: 'banco-do-auto.html' },
      { label: 'Veículos elétricos', href: 'financiar-veiculos-eletricos.html' },
      { label: 'Seguro Auto', href: 'seguro-santander-auto.html' },
      { label: 'Leilão de veículos', href: 'leilao-de-veiculos.html' },
      { label: 'Open Finance', href: 'open-finance.html' },
      { label: 'Empréstimo com Garantia de Veículo', href: 'emprestimo-garantia-carro.html' },
    ],
  },
  {
    title: 'Ajuda',
    links: [
      { label: 'Canais de atendimento', href: 'canais-de-atendimento.html' },
      { label: 'Dúvidas frequentes', href: 'duvidas-frequentes.html' },
      { label: 'Fraudes e segurança', href: 'denuncias-e-fraudes.html' },
    ],
  },
  {
    title: 'Termos e condições',
    links: [
      {
        label: 'Condições gerais de CDC Auto',
        href: 'assets/seguro/pdf/14-11-25-em-diante.pdf',
        external: true,
      },
      {
        label: 'Condições gerais de Empréstimo com garantia de veículo',
        href: 'pdf/emprestimo-garantia-carro/condicoes-gerais-SIM-santander.pdf',
        external: true,
      },
      { label: 'Tabela de tarifas', href: 'pdf/Tabela-de-Tarifas.pdf', external: true },
      { label: 'Política de privacidade', href: 'politica-de-privacidade.html' },
      {
        label: 'Parceiros oferta conta corrente',
        href: 'pdf/parceiros-oferta-conta-corrente-set26.pdf',
        external: true,
      },
    ],
  },
];

function EmDiaValeMaisFooter() {
  return (
    <footer id="em-dia-vale-mais-footer">
      <ContainerHome24>
        <div className="footer-categories">
          {categories.map((category) => (
            <div className="footer-column" key={category.title}>
              <span className="footer-topic">{category.title}</span>
              {category.links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target={link.external ? '_blank' : undefined}
                  rel={link.external ? 'noopener' : undefined}
                  className="footer-link"
                >
                  {link.label}
                </a>
              ))}
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <a href="." className="footer-logo">
            <img src="static/amp/shared/assets/logo_2.svg" alt="Santander Financiamentos" />
          </a>
          <div className="footer-legal">
            <span>
              ® SANTANDER SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A., CNPJ:
              07.707.650/0001-10
            </span>
            <span>
              Avenida Presidente Juscelino Kubitschek, nº 2041 - CJ 231 - Bloco A, Cond. WTORRE JK -
              Vila Nova Conceição - São Paulo-SP.
            </span>
          </div>
        </div>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </footer>
  );
}

export default EmDiaValeMaisFooter;
